import styled from 'styled-components'

const LinearSliderStyle = styled.div`
    --lsSlidePaddingH: var(--sp7x);
    --lsBigSlideWidth: 34.375%;
    --lsBigSlideProportion: 141%;
    --lsSmallSlideWidth: 25.65%;
    --lsSmallSlideTopImageWidth: 63.567%;
    --lsSmallSlideTopImageProportion: 141%;
    --lsSmallSlideBottomImageProportion: 63.56%;

    //! Drag Cursor
    --dcSize: var(--sp13x);

    position: relative;
    cursor: none;

    .swiper-wrapper {
        display: flex;
        align-items: stretch;
        user-select: none;
        margin-left: calc(var(--lsSmallSlideWidth) / -1.7);
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        
        .swiper-slide {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            height: auto;
            padding: 0 calc(var(--lsSlidePaddingH) / 2);
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            transform: translate3d(0,0,0);
            -webkit-transform: translate3d(0,0,0);
            -webkit-perspective: 1000;
            perspective: 1000;

            .imageCont {
                border-radius: var(--sp2x);
                overflow: hidden;
            }

            &.big-slide {
                width: calc(var(--lsBigSlideWidth) + var(--lsSlidePaddingH));

                .imageCont {
                    --imagePaddingTop: var(--lsBigSlideProportion)
                }
            }

            &.double-slide {
                width: calc(var(--lsSmallSlideWidth) + var(--lsSlidePaddingH));

                .top-slide {
                    width: var(--lsSmallSlideTopImageWidth);
                    margin-bottom: var(--lsSlidePaddingH);

                    .imageCont {
                        --imagePaddingTop: var(--lsSmallSlideTopImageProportion);
                    }

                    &.top-right-slide {
                        align-self: flex-end;
                    }
                }

                .bottom-slide {
                    .imageCont {
                        --imagePaddingTop: var(--lsSmallSlideBottomImageProportion);
                    }
                }
            }

            .ls-item-inner-cont {
                width: 100%;

                
            }
        }
    }

    .cursor-drag {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: calc(-1 * var(--dcSize));
        left: calc(-1 * var(--dcSize));
        width: var(--dcSize);
        height: var(--dcSize);
        color: var(--primaryColor1);
        border-radius: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        pointer-events: none;
    }

    @media not all and (hover: hover) {
        .cursor-drag {
            display: none;
        }
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --lsSlidePaddingH: var(--sp5x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --lsSlidePaddingH: var(--sp4x);
        --lsBigSlideWidth: 34.3708%;
        --lsSmallSlideWidth: 25.629%;
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --lsSlidePaddingH: var(--sp4x);
        --lsBigSlideWidth: 36.041%;
        --lsSmallSlideWidth: 26.875%;
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --lsSlidePaddingH: var(--sp3x);
        --lsBigSlideWidth: 34.375%;
        --lsSmallSlideWidth: 25.625%;
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize})  and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --lsSlidePaddingH: var(--sp3x);
        --lsBigSlideWidth: 42.968%;
        --lsSmallSlideWidth: 32.031%;

        //! Drag Cursor
        --dcSize: var(--sp10x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS})  and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --lsSlidePaddingH: var(--sp3x);
        --lsBigSlideWidth: 57.291%;
        --lsSmallSlideWidth: 42.708%;

        //! Drag Cursor
        --dcSize: var(--sp10x);
    }

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --lsSlidePaddingH: var(--sp2x);
        --lsBigSlideWidth: 91.062%;
        --lsSmallSlideWidth: 67.632%;

        //! Drag Cursor
        --dcSize: var(--sp10x);
    }
`

export default LinearSliderStyle